module.exports = __webpack_public_path__ + "img/add-s-4.f73d8bb0.png";